import React from 'react';

import { selectedComponent, selectComponent } from '../../redux/selectedComponentSlice';
import { useSelector, useDispatch } from 'react-redux';
import EditorInputs from '../canvas/Editors/EditorInputs';
import { useDisclosure, Popover, PopoverContent } from '@chakra-ui/react';

const PopoverEditComponent = () => {
	const dispatch = useDispatch();
	const selectedComponentValue = useSelector(selectedComponent);
	const { onOpen, onClose, isOpen } = useDisclosure();

	React.useEffect(() => {
		if (!selectedComponentValue || !selectedComponentValue.props) {
			onClose();
		} else {
			onOpen();
		}
	}, [selectedComponentValue]);

	if (!selectedComponentValue || !selectedComponentValue.props) return null;

	return (
		<Popover zIndex={9999} onOpen={onOpen} onClose={(e) => onClose(dispatch(selectComponent(null)))} isOpen={isOpen}>
			<PopoverContent variants={{}}>
				<EditorInputs />
			</PopoverContent>
		</Popover>
	);
};

export default PopoverEditComponent;
